import { SwyftxPlatform } from 'src/lib/utils/utils.types';
import { create } from 'zustand';

type ThemeState = {
  mobileMenuOpen: boolean;
  switchPlatform?: SwyftxPlatform;
  setMobileMenuOpen: (mobileMenuOpen: boolean) => void;
  setSwitchPlatform: (switchPlatform?: SwyftxPlatform) => void;
};

const SWITCH_PLATFORM_DURATION = 3000;

const useLayoutStore = create<ThemeState>()((set) => ({
  mobileMenuOpen: false,
  setMobileMenuOpen: (mobileMenuOpen: boolean) => {
    set({ mobileMenuOpen });
  },
  setSwitchPlatform: (switchPlatform?: SwyftxPlatform) => {
    set({ switchPlatform });
  },
}));

export { useLayoutStore, SWITCH_PLATFORM_DURATION };
